import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const openWeatherMap = defineConnector({
  identifier: "openWeatherMap",
  name: "OpenWeatherMap",
  tagLine: "Weather data API",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.openweathermap\\.org/.*",
  auth: (app) => queryAuth([{ name: "appid", value: app.secret.accessToken }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign up at [OpenWeatherMap](https://openweathermap.org/) and go to **API keys** in your account to generate a key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.openweathermap.org/data/2.5/weather?q=London",
  },
});
